import { render, staticRenderFns } from "./LiniProduksiSection.vue?vue&type=template&id=35e1961f&scoped=true"
import script from "./LiniProduksiSection.vue?vue&type=script&lang=js"
export * from "./LiniProduksiSection.vue?vue&type=script&lang=js"
import style0 from "./LiniProduksiSection.vue?vue&type=style&index=0&id=35e1961f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1961f",
  null
  
)

export default component.exports